import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosClient from '../../utils/axiosClient';
import '../../App.css';
import mcpTokenRemoval from '../../utils/mcpTokenRemoval';

function AuthLoader() {
	const { token } = useParams();
	const navigate = useNavigate();

	const WHATSAPP_URL =
		'https://api.whatsapp.com/send?phone=60167015382&text=Hi!%20I%27m%20interested%20to%20join%20Haleon%20Rewards.';

	useEffect(() => {
		if (typeof mcpTokenRemoval === 'function') mcpTokenRemoval();
	}, []);

	useEffect(() => {
		async function fetchData(decodedToken) {
			try {
				localStorage.setItem('HALEON-REWARDS_USER_TOKEN', decodedToken);

				const res = await axiosClient.get('/users/details', {
					headers: {
						Authorization: `Bearer ${decodedToken}`,
					},
				});

				const data = res.data;
				const personalInfo = data?.data?.personalInfo;

				if (
					data.success &&
					personalInfo &&
					Object.keys(personalInfo).length > 0
				) {
					navigate('/home', { state: { from: 'login' } });
				} else {
					localStorage.removeItem('HALEON-REWARDS_USER_TOKEN');
					window.location.href = WHATSAPP_URL;
				}
			} catch (error) {
				console.error('Auth failed:', error);
				navigate('/', { replace: true });
			}
		}

		if (token) {
			try {
				const decodedToken = atob(token);
				fetchData(decodedToken);
			} catch (e) {
				console.error('Invalid token format');
				window.location.href = WHATSAPP_URL;
			}
		} else window.location.href = WHATSAPP_URL;
	}, [token, navigate]);

	return (
		<div
			style={{
				alignItems: 'center',
				justifyContent: 'center',
				display: 'flex',
				backgroundColor: '#554e4e9e',
				height: '100vh',
			}}
		>
			<div className="loader"></div>
		</div>
	);
}

export default AuthLoader;
